import { Component, ojs, app } from "modular-openscriptjs";
import { either, isMobile } from "../../helpers";
import SideNav from "../SideNav";
import { pc, resolveCurrentPage } from "../../declarations";

const h = app("h");

ojs(SideNav);

export default class MainContent extends Component {
	/**
	 *
	 * @param {import("modular-openscriptjs").State<boolean>} authState
	 * @param  {...any} args
	 * @returns {HTMLElement}
	 */
	render(authState, ...args) {
		return h.div(
			{ class: "container-xl", $class: 'd-block w-100', $ojs_hook: "main-content-container", },
			either(authState.value, {
				$class: `d-block flex-fill ${pc.sideNavCollapsed.value? "col-lg-10" : "col-lg-8"}`,
				$style: "transition: width 0.3s ease;",
			}),
			h.call(() => {
				return resolveCurrentPage()
			}),
			...args,
		);
	}
}
